import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

const Join = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const nameRef = useRef(null);
  useEffect(() => {
    nameRef.current.focus();
  }, []);
  return (
    <div className="sm:w-1/3 sm:mx-auto mx-4 my-10 p-5 shadow-lg rounded-lg">
      <div className="text-4xl font-semibold my-5 text-gray-500">Join Chatroom</div>

      <div>
        <input
          ref={nameRef}
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          className="w-full px-5 py-2 my-3 border-2 text-xl rounded focus:border-indigo-600 focus:outline-none"
          placeholder="Your Name ; eg : Elon Musk"
        />
      </div>
      <div>
        <input
          type="text"
          value={room}
          onChange={(e) => setRoom(e.target.value)}
          className="w-full px-5 py-2 my-3 border-2 text-xl rounded focus:border-indigo-600 focus:outline-none"
          placeholder="Room Name ; eg : spaceX"
        />
      </div>
      <div>
        <Link
          onClick={(event) => (!name || !room ? event.preventDefault() : null)}
          className="join-button"
          to={`/chat?name=${name}&room=${room}`}
        >
          Join
        </Link>
      </div>
    </div>
  );
};

export default Join;
